import React from 'react';

import StringBreaker from 'as-ui-kit/controls/StringBreaker';

import styles from './styles.modules.scss';
import i18nStrings from './strings';
import { useLocalized } from 'utils/useLocalized';

const EmptyResults = () => {
    const strings = useLocalized(i18nStrings);

    return (
        <div className={styles['empty-report']}>
            <div className={styles['content']}>
                <svg 
                    height="36" 
                    viewBox="0 0 45 36" 
                    width="45" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 0h11.429v6H0V0zm14.286 0h7.143v6h-7.143V0zm10 0H45v6H24.286V0zM0 10h11.429v6H0v-6zm14.286 0h7.143v6h-7.143v-6zm10 0H45v6H24.286v-6zM0 20h11.429v6H0v-6zm14.286 0h7.143v6h-7.143v-6zm10 0H45v6H24.286v-6zM0 30h11.429v6H0v-6zm14.286 0h7.143v6h-7.143v-6zm10 0H45v6H24.286v-6z" // eslint-disable-line
                        fill="#39444F"
                        fillOpacity=".202"
                        fillRule="evenodd"
                    />
                </svg>
                <div className={styles['no-data-text']}>
                    <StringBreaker>
                        {strings.noData}
                    </StringBreaker>
                </div>
            </div>
        </div>
    );
};

export default EmptyResults;
